module.exports = __webpack_public_path__ + "static/img/tugging_skin-01.850e8e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/tugging_skin-01.jpg
// module id = 295
// module chunks = 1